import React from 'react';
import "../../../styles/DefenceStyles/DefenceOverview.css"

// BACKGROUND IMAGE
import heroBg from '../../.../../../assets/images/Defence/Overview/breakout.png';

export default function DefenceHeroCTA() {
  return (
   <section
  className="defence-cta"
  style={{ backgroundImage: `url(${heroBg})` }}
>
  <div className="defence-cta-overlay">
    <div className="defence-cta-content">
      <h1>Secure. Indigenous. Mission-Ready.</h1>

      <p>
        Trusted by defence forces for mission-critical electronic solutions
      </p>

      <button className="defence-cta-btn">
        Explore Defence Capabilities
      </button>
    </div>
  </div>
</section>
  );
}
